<template>
    <div class="layout-refresh-interval-settings w-full">
        <RedesignBaseForm
            ref="generalSettingsForm"
            class="space-y-10"
        >
            <RedesignVerticalFormItem
                v-for="parameter in timeParameters"
                :key="parameter.LayoutParameterName"
                :title="getLayoutConfigParameterTranslation(parameter.LayoutParameterName)"
                :description="getLayoutConfigParameterInfoTranslation(parameter.LayoutParameterName)"
                class="layout-timer-item"
            >
                <base-time-input
                    v-model="parameter.Value"
                    :min-value="0"
                    :step="1"
                    class="input-number"
                    max-width="200px"
                    color="primary"
                />
            </RedesignVerticalFormItem>
            <RedesignVerticalFormItem
                v-for="parameter in booleanParameters"
                :key="parameter.LayoutParameterName"
                :title="getLayoutConfigParameterTranslation(parameter.LayoutParameterName)"
                :description="getLayoutConfigParameterInfoTranslation(parameter.LayoutParameterName)"
                class="layout-timer-item"
            >
                <RedesignSwitch
                    v-model="parameter.Value"
                    active-value="1"
                    inactive-value="0"
                />
            </RedesignVerticalFormItem>
        </RedesignBaseForm>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ILayoutItem } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import RedesignBaseForm from '@/components/RedesignBaseComponents/Form/RedesignBaseForm.vue'
import { getLayoutConfigParameterInfoTranslation, getLayoutConfigParameterTranslation } from '@/helpers/translation'
import RedesignVerticalFormItem from '@/components/RedesignBaseComponents/Form/RedesignVerticalFormItem.vue'
import BaseTimeInput from '@/components/Common/BaseTimeInput.vue'
import RedesignSwitch from '@/components/RedesignBaseComponents/Inputs/RedesignSwitch.vue'

const SETUP_INTERVAL_PARAMETERS = [
    'MinRefreshInterval',
    'RefreshRealTimeDataDelay',
    'ReportInterval',
]
const SETUP_BOOLEAN_PARAMETERS = [
    'ReportSwitching',
    'ReportRefresh'
]

const props = defineProps<{
    value: ILayoutItem
}>()
const emit = defineEmits<{
    (e: 'input', value: ILayoutItem): void
    (e: 'update:value', value: ILayoutItem): void
}>()

const layoutLocalModel = useVModel(props, 'value', emit, { eventName: 'input' })

const timeParameters = computed(() => {
    return (layoutLocalModel.value?.LayoutParametersList || []).filter(parameter => SETUP_INTERVAL_PARAMETERS.includes(parameter.LayoutParameterName))
})
const booleanParameters = computed(() => {
    return (layoutLocalModel.value?.LayoutParametersList || []).filter(parameter => SETUP_BOOLEAN_PARAMETERS.includes(parameter.LayoutParameterName))

})
</script>
